import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useNavigate } from 'react-router-dom';
import type { OrganisationInviteRead } from '@/client/types.gen';

interface PendingInvitesAlertProps {
  invites: OrganisationInviteRead[];
  className?: string;
}

export function PendingInvitesAlert({
  invites,
  className = '',
}: PendingInvitesAlertProps) {
  const navigate = useNavigate();

  if (invites.length === 0) {
    return null;
  }

  const handleViewInvites = () => {
    navigate('/dashboard/team-management/invites');
  };

  return (
    <Alert className={`border-amber-500 ${className}`}>
      <Bell className="h-4 w-4 text-amber-500" />
      <AlertTitle className="flex items-center gap-2">
        Pending Invites
        <Badge variant="outline" className="text-amber-500 border-amber-500">
          {invites.length}
        </Badge>
      </AlertTitle>
      <AlertDescription>
        You have {invites.length} pending team{' '}
        {invites.length === 1 ? 'invite' : 'invites'}.
        <div className="mt-2">
          <Button
            size="sm"
            variant="outline"
            className="border-amber-500 text-amber-500 hover:text-amber-600 hover:border-amber-600"
            onClick={handleViewInvites}
          >
            View Invites
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
}
